import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'female-water-fasting': {
			// /water-fasting-f?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_water_fasting_pr_guide~1
			funnel: {
				id: 'ob-water-fasting-female-pr-guide',
				locale: ['en'],
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_water_fasting_pr_guide~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_water_fasting_pr_guide'),
			},
		},
	},
]

export default config
